import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { versionsQueryKeys } from './queryKeyFactory';
import { GetDocumentVersionsRequest } from '../../Model/requests/GetDocumentVersionsRequest';
import { DocumentVersionResponse } from '../../Model/responseDtos/DocumentVersionResponse';

export function useGetDocumentVersions(
  dto: GetDocumentVersionsRequest,
  options?: Partial<UseQueryOptions<DocumentVersionResponse[], unknown>>
): UseQueryResult<DocumentVersionResponse[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDocumentVersions = () => {
    if (servicesCtx?.versionsService) {
      return servicesCtx.versionsService.getVersions(dto);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: versionsQueryKeys.getVersions(dto),
    queryFn: getDocumentVersions,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: dto.indexId >= 0,
    ...options
  });
}
